import _app from '../server';

// react
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

// layouts
import { PrivateLayout } from 'components/layouts';
// pages
import { Login, Page404, Page500 } from 'components/pages';

// core-ui------------------------------------------------------------------
// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';
// Import Main styles for this application
import 'assets/scss/style.css'
// --------------------------------------------------------------------------

import { Connector } from 'mqtt-react';

class Routing extends Component {
  constructor(props) {
    super(props)
    this.state = {
      unmounted: false
    }
  }
  componentWillMount() {
    //console.log("=======componentWillMount===============MQTT-CLIENT : ", Connector);
    // MqttClient.end();
    this.setState({ unmounted: false })
  }
  componentWillUnmount() {
    //console.log("==========componentWillUnmount==========MQTT-CLIENT : ", Connector);
    //MqttClient.end();
    this.setState({ unmounted: true })
  }

  render() {
    return (
      <div>
        <Switch>
          <Route exact path="/login" render={props => (<Login {...props} />)} />
          <Route exact path="/404" render={props => (<Page404 {...props} />)} />
          <Route exact path="/500" render={props => (<Page500 {...props} />)} />
          <Route path="/" render={props => (
            <Connector mqttProps={_app.mqttBroker}>
              <PrivateLayout {...props} />
            </Connector>
          )} />
        </Switch>
      </div>
    )
  }
}

export default Routing;


// WEBPACK FOOTER //
// ./src/components/Routing.js